import { Component, OnInit, Inject, Input } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { LookupService } from 'src/app/Services/LookupService';
import { ILookupBase } from 'src/app/Models/ILookupBase';
import { saveAs } from 'node_modules/file-saver/src/FileSaver';
import { IReportParameter } from 'src/app/Models/IReportParameter';
import { IReportRequest } from 'src/app/Models/IReportRequest';
import { ReportService } from 'src/app/Services/ReportService';
import { IReportPDF } from 'src/app/Models/IReportPDF';
import { Globals } from '../../../globals';
import { IStudentSearchParameters } from 'src/app/Models/IStudentSearchParameters';

@Component({
  selector: 'app-_126_ServicesDeliveredDetailRptParams',
  templateUrl: './_126_ServicesDeliveredDetailRptParams.component.html',
  styleUrls: ['./_126_ServicesDeliveredDetailRptParams.component.css']
})
export class _126_ServicesDeliveredDetailRptParamsComponent implements OnInit {

  _baseUrl: string;
  _myGlobals: Globals;

  date: Date; 
  selectedPAU: SelectItem; selectedSite: SelectItem; selectedStudent: SelectItem;  
  _PAUid: string = null; _siteId: string = null; _studentId: string = null; _selectedSchoolYear: string = null;
  public showSpinner: boolean = false;
  fromDate: Date;
  toDate: Date;
  minDate: Date;
  maxDate: Date;

  //lookups
  lookupSite: any = [];
  lookupSiteName: string;
  lookupSiteAddress: string;
  lookupSiteList: ILookupBase[] = [{ value: null, label: "-- Select PAU to view sites --", shortText: null, updatedOn: null }];
  lookupPAUList: ILookupBase[] = [{ value: null, label: "-- NO PAUs --", shortText: null, updatedOn: null }];
  lookupStudentList: ILookupBase[] = [{ value: null, label: "-- NO STUDENTS TO VIEW ! --", shortText: null, updatedOn: null }];
  _lookupService: LookupService;
  _reportService: ReportService;

  constructor(lookupService: LookupService, reportService: ReportService, globals: Globals,
    @Inject('BASE_URL') baseUrl: string
  ) {
    this._lookupService = lookupService;
    this._reportService = reportService;
    this._baseUrl = baseUrl;
    this._myGlobals = globals;
    this.date = new Date();
  }

  ngOnInit() {
    let today = new Date();
    this.date = new Date(today.getMonth() + 1 + '/' + today.getDate() + '/' + today.getFullYear());
    this.fromDate = new Date((today.getMonth() + 1) > 2 ? today.getMonth() - 1 + '/01/' + today.getFullYear() : '11/01/' + (today.getFullYear() - 1));
    this.toDate = new Date();
    this.minDate = new Date('01/01/2021');
    this.maxDate = new Date();
    this.LoadLookupValues();
  }

  LoadLookupValues(): void {
    this._lookupService.getLookupPAUs(this._baseUrl + 'api/Lookup/GetLookupPauList/' + this.date.toISOString().slice(0, 10) + '^' + this.date.toISOString().slice(0, 10))
      .subscribe((res: ILookupBase[]) => {
        if (!res || res.toString() === "") {
          this.lookupPAUList = [{ value: null, label: "-- NO PAUS ! --", shortText: null, updatedOn: null }]
        }
        else {
          this.lookupPAUList = [{ value: null, label: "-- ALL PAUs --", shortText: null, updatedOn: null }].concat(res);
          this.selectedPAU = this.lookupPAUList[0];
        }

        this._lookupService.getLookupSites(this._baseUrl + 'api/Lookup/GetLookupSiteList/' + this.date.toISOString().slice(0, 10) + '^' + this.date.toISOString().slice(0, 10) + '^' + '')
          .subscribe((res: ILookupBase[]) => {
            if (!res || res.toString() === "") {
              this.lookupSiteList = [{ value: null, label: "-- NO SITES TO VIEW ! --", shortText: null, updatedOn: null }]
            }
            else {
              this.lookupSiteList = [{ value: null, label: "-- All Sites --", shortText: null, updatedOn: null }].concat(res);
              this.selectedSite = this.lookupSiteList[0];

              //Student lookup
              let params = {} as IStudentSearchParameters;
              params.asOfDate = this.date/*.toISOString().slice(0, 10)*/;
              params.siteIdArray = this.getSiteIdList().split('^');

              this._lookupService.getLookupStudent(this._baseUrl + 'api/Lookup/GetSpedStudentList/', params)
                .subscribe((res: ILookupBase[]) => {
                  if (!res || res.toString() === "") {
                    this.lookupStudentList = [{ value: null, label: "-- NO STUDENTS TO VIEW ! --", shortText: null, updatedOn: null }]
                    this._studentId = null;
                  }
                  else {
                    this.lookupStudentList = [{ value: null, label: "-- Select a Student --", shortText: null, updatedOn: null }].concat(res);
                    this._studentId = null;
                    this.selectedStudent = this.lookupStudentList[0];
                  }
                },
                  err => console.error(err)
                );

            }
          },
            err => console.error(err)
          );
      },
        err => console.error(err)
      );
  }

  LookupSites(id): void {
    this._PAUid = id.value;
    var param = (typeof id == "string") ? id : (id.value != null ? id.value : '');
    this._lookupService.getLookupSites(this._baseUrl + 'api/Lookup/getLookupSiteList/' + this.date.toISOString().slice(0, 10) + '^' + this.date.toISOString().slice(0, 10) + '^' + param)
      .subscribe((res: ILookupBase[]) => {
        if (!res || res.toString() === "") {
          this.lookupSiteList = [{ value: null, label: "-- NO SITES TO VIEW ! --", shortText: null, updatedOn: null }]
        }
        else {
          this.lookupSiteList = [{ value: null, label: "-- All Sites --", shortText: null, updatedOn: null }].concat(res);
          this.selectedSite = this.lookupSiteList[0];

          //Student lookup
          let params = {} as IStudentSearchParameters;
          params.asOfDate = this.date/*.toISOString().slice(0, 10)*/;
          params.siteIdArray = this.getSiteIdList().split('^');

          this._lookupService.getLookupStudent(this._baseUrl + 'api/Lookup/GetSpedStudentList/', params)
            .subscribe((res: ILookupBase[]) => {
              if (!res || res.toString() === "") {
                this.lookupStudentList = [{ value: null, label: "-- NO STUDENTS TO VIEW ! --", shortText: null, updatedOn: null }]
                this._studentId = null;
              }
              else {
                this.lookupStudentList = [{ value: '', label: "-- Select a Student --", shortText: null, updatedOn: null }].concat(res);
                this._studentId = null;
                this.selectedStudent = this.lookupStudentList[0];
              }
            },
              err => console.error(err)
            );

        }
      },
        err => console.error(err)
      );
  }

  setSite(id): void {
    this._siteId = id.value;

    //Student lookup
    let params = {} as IStudentSearchParameters;
    params.asOfDate = this.date/*.toISOString().slice(0, 10)*/;
    params.siteIdArray = this.getSiteIdList().split('^');

    this._lookupService.getLookupStudent(this._baseUrl + 'api/Lookup/GetSpedStudentList/', params)
      .subscribe((res: ILookupBase[]) => {
        if (!res || res.toString() === "") {
          this.lookupStudentList = [{ value: null, label: "-- NO STUDENTS TO VIEW ! --", shortText: null, updatedOn: null }];
          this._studentId = null;
        }
        else {
          this.lookupStudentList = [{ value: null, label: "-- All Students --", shortText: null, updatedOn: null }].concat(res);
          this._studentId = null;
          this.selectedStudent = this.lookupStudentList[0];
        }
      },
        err => console.error(err)
      );
  }

  setStudent(id): void {
    this._studentId = id.value;
  }

  getSiteIdList(): string {
    if (this._siteId != null) { return this._siteId }
    else {
      let siteIdList: string;
      this.lookupSiteList.forEach((site, index, arr) => {
        if ((site.label != null) && (site.label != "-- Select PAU to view sites --") && (site.label != "-- NO SITES TO VIEW --")) {
          if (site.label != "-- All Sites --") siteIdList += site.value + '^';
        }
      });
      return siteIdList.slice(0, siteIdList.length - 1).replace('undefined', '');
    }
  }

  getSelectedDateData() {
    this.LoadLookupValues();
  }

  getstudentId(): string {
    let studentId: string;

    if (this.selectedStudent.value == null) {
      studentId = '';
    }
    else {
      studentId = this.selectedStudent.value;
    }
    return studentId;
  }

  viewReport() {
    var selectedStudentValue = this.lookupStudentList.find(z => z.value === this._studentId).label;

    let reportParamArray: IReportParameter[] = [];
    reportParamArray.push(
      { parameterName: 'LocalStudentId', parameterValue: this._studentId },
      { parameterName: 'SelectedStudent', parameterValue: selectedStudentValue },
      { parameterName: 'FromDate', parameterValue: this.fromDate.toISOString() },
      { parameterName: 'ToDate', parameterValue: this.toDate.toISOString() }
    );

    let now = new Date();
    let localReportFileName = '126-ServicesDeliveredDetail_' + now.toLocaleDateString() + '_' + now.toTimeString().slice(0, 5) + '.pdf';
    let reportRequest = {} as IReportRequest;
    reportRequest.prefix = 'SpedXReports';
    reportRequest.reportFileName = "IEP_SpecialEd_ServicesDeliveredDetail";
    reportRequest.reportSpecificParameterArray = reportParamArray;

    this.showSpinner = true;
    this._reportService.getPDFReport(reportRequest).subscribe((res: IReportPDF) => {
      var binaryString = window.atob(res.base64FileContent);
      var stringLength = binaryString.length;
      var bytes = new Uint8Array(stringLength);
      for (var i = 0; i < stringLength; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      this.showSpinner = false;
      saveAs(new Blob([bytes], { type: 'application/pdf' }), localReportFileName);
    },
      err => {
        this.showSpinner = false;
        console.error(err);
      }
    );
  }

}
